module.exports = __webpack_public_path__ + "static/media/image2.b7181707.svg";